// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Mipqt","label":"style_label__82Ai-"};